import { render, staticRenderFns } from "./AsignarTicket.vue?vue&type=template&id=5b2827a6"
import script from "./AsignarTicket.vue?vue&type=script&lang=js"
export * from "./AsignarTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports